'use client';

export { default } from './DialogContent';
export { default as dialogContentClasses } from './dialogContentClasses';
export * from './dialogContentClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/DialogContent/index.js
// module id = 843
// module chunks = 22